import {FontAwesomeIcon, Text, Wrapper} from 'components';
import styles from './styles.module.scss';

function TableColumn(title, titleIcon, key,width=180, render=null) {
    return {
        title: <Wrapper className={styles.wrapper}>
            {titleIcon && 
            <FontAwesomeIcon className={styles.icon} icon={titleIcon} name={titleIcon}/>}
            <Text className={styles.tableTitle}>{title}</Text>
            </Wrapper>,
        dataIndex: key,
        key: key,
        width: width,
        align: "left",
        render: render,
    }
}

export default TableColumn
